export default __webpack_public_path__ + "static/media/annex13.43429938.png";